import { Outlet, createFileRoute } from '@tanstack/react-router'

import { toStringList } from '@/lib/searchParams'

export const Route = createFileRoute('/_app/control-room/workflow/$stepId')({
  component: () => <Outlet />,
  validateSearch: (
    search: Record<string, unknown>,
  ): { labwareIds?: string[] } => {
    const labwareIds = toStringList(search.labwareIds)
    return labwareIds.length > 0 ? { labwareIds } : {}
  },
})
